<template>
  <div class="page_all">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
    <div class="return_link">
      <router-link to="/shelterList">＞ 避難先</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div v-if="changeFlg" class="title">避難先の編集</div>
        <div v-else class="title">避難先の追加</div>
      </div>
      <button v-if="changeFlg" :disabled="$v.$invalid || this.updating" class="btn_general" v-on:click="shelterUpdate()">更新</button>
      <button v-else :disabled="$v.$invalid || this.updating" class="btn_general" v-on:click="shelterAdd()">追加</button>

    </div>
    <div class="area_radios_div">
      <div class="area_radio_div" v-for="language in languages" v-bind:key="language.language_id">
        <input class="area_radio_input" :id="'ja_radio_' + language.language_id" type="radio" :value="language.language_id" v-model=languageRadio>
        <label class="area_radio_label" :for='"ja_radio_" + language.language_id'>
            {{ language.language_name}}
        </label>
      </div>
    </div>
    <div v-if="message != ''" class="message">
      <div class="error">{{ message }}</div>
    </div>
    <div class="page_main">
      <!-- jaのみ -->
      <table v-if="languageRadio == 1" class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_top">
            <div class="tr_title_top">名称</div>
            <div class="tr_input">
              <input v-model.trim="$v.shelterName.$model" type="text" class="name_input" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.shelterName.$dirty">
                  <div class="error" v-if="!$v.shelterName.required">名称は必須入力です。</div>
                  <div class="error" v-if="!$v.shelterName.maxLength">名称は{{ $v.shelterName.$params.maxLength.max }}文字以内で入力してください。</div>
                  <div class="error" v-if="!$v.shelterName.customShelterName">すでに登録されている名称です。</div>
                </div>
              </div>
            </div>
          </tr>
          <tr class="tr_top">
            <div class="tr_title">緯度</div>
            <div class="tr_input">
              <input v-model.trim="$v.latitude.$model" type="text" class="name_lati_input" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.latitude.$dirty">
                  <div class="error" v-if="!$v.latitude.required">緯度は必須入力です。</div>
                  <div class="error" v-if="!$v.latitude.maxLength">緯度は{{ $v.latitude.$params.maxLength.max }}文字以内で入力してください。</div>
                  <div class="error" v-if="!$v.latitude.customLatitude">不正な入力です。</div>
                </div>
              </div>
            </div>
          </tr>
          <tr class="tr_top">
            <div class="tr_title">経度</div>
            <div class="tr_input">
              <input v-model.trim="$v.longitude.$model" type="text" class="name_lati_input" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.longitude.$dirty">
                  <div class="error" v-if="!$v.longitude.required">経度は必須入力です。</div>
                  <div class="error" v-if="!$v.longitude.maxLength">経度は{{ $v.longitude.$params.maxLength.max }}文字以内で入力してください。</div>
                  <div class="error" v-if="!$v.longitude.customLongitude">不正な入力です。</div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>      
      <table v-if="languageRadio == 2" class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_top">
            <div class="tr_title_top">名称(英語)</div>
            <div class="tr_input">
              <input v-model.trim="$v.shelterName_ei.$model" type="text" class="name_input" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.shelterName_ei.$dirty">
                  <div class="error" v-if="!$v.shelterName_ei.maxLength">名称(英語)は{{ $v.shelterName_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
      <table v-if="languageRadio == 3" class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_top">
            <div class="tr_title_top">名称(韓国語)</div>
            <div class="tr_input">
              <input v-model.trim="$v.shelterName_kan.$model" type="text" class="name_input" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.shelterName_kan.$dirty">
                  <div class="error" v-if="!$v.shelterName_kan.maxLength">名称(韓国語)は{{ $v.shelterName_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
      <table v-if="languageRadio == 4" class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_top">
            <div class="tr_title_top">名称(中国語:繁体字)</div>
            <div class="tr_input">
              <input v-model.trim="$v.shelterName_chu_han.$model" type="text" class="name_input" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.shelterName_chu_han.$dirty">
                  <div class="error" v-if="!$v.shelterName_chu_han.maxLength">名称(韓国語)は{{ $v.shelterName_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
      <table v-if="languageRadio == 5" class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_top">
            <div class="tr_title_top">名称(中国語:簡体字)</div>
            <div class="tr_input">
              <input v-model.trim="$v.shelterName_chu_kan.$model" type="text" class="name_input" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.shelterName_chu_kan.$dirty">
                  <div class="error" v-if="!$v.shelterName_chu_kan.maxLength">名称(韓国語)は{{ $v.shelterName_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
      <br/>
      <br/>
      <!-- jaのみ -->
      <template v-if="languageRadio == 1">
        <!-- グループ -->
        <table>
          <thead>
            <tr>
              <th class="th_check">
                <input type="checkbox" v-model="isAllGroupSelected" class="check_area" v-bind:disabled="disabledFlg">
              </th>
              <th class="th_area">グループ名</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="group in groups" v-bind:key="group.group_id">
              <td>
                <input type="checkbox" v-bind:value=group.group_id v-model="selectedGroups" class="check_area" v-bind:disabled="disabledFlg || group.areas.length == 0">
              </td>
              <td v-if="group.areas.length == 0" class="area_name_disabled" disabled="true">{{ group.group_name }}</td>
              <td v-else class="area_name" disabled="true">
                <span>{{ group.group_name }}</span>
                <span class="group_link" v-on:click="modalGroupAreas(group)">登録されている地域</span>
                <modal :name="'modal_group_areas_'+group.group_id" 
                  :draggable="false" 
                  :resizable="false" 
                  :scrollable="true" 
                  height="auto">
                  <div class="modal_header_group">
                    <p class="modal_title_group">{{ group.group_name }}に登録されている地域</p>
                  </div>
                  <div class="modal-body_group">
                    <ul v-for="area in group.areas" :key="area.area_id">
                      <li>{{ area.area_name }}</li>
                    </ul>
                  </div>
                  <div class="modal-btn_group">
                    <div class="modal_btn_div_group">
                      <button class="btn btn-outline-primary" @click="close_modal_group_areas(group)">閉じる</button>
                    </div>
                  </div>  
                </modal>
              </td>
            </tr>
          </tbody>
        </table>
        <br/>
        <br/>
        <!-- ここまでグループ -->
        <!-- 災害種別 -->
        <table>
          <thead>
            <tr>
              <th class="th_check">
                <input type="checkbox" v-model="isAllDisasterSelected" class="check_area" v-bind:disabled="disabledFlg">
              </th>
              <th class="th_area">災害種別</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="disaster in disasters" v-bind:key="disaster.id">
              <td>
                <input type="checkbox" v-bind:value=disaster.disaster_id v-model="selectedDisasters" class="check_area" v-bind:disabled="disabledFlg">
              </td>
              <td class="area_name" disabled="true">{{ disaster.disaster_name }}</td>
            </tr>
          </tbody>
        </table>
        <!-- ここまで災害種別 -->
        <br/>
        <br/>
      </template>
      <br/>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import IconImage from "@/img/push_icon.png";

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import mixinFilters from './mixin/filters'

const customLatitude = (latitude) => {
  if (!latitude || typeof latitude !== "string" || latitude === "") {
    return true;
  }

  if (!latitude.match(/^[0-9-]/) || latitude.replace('-', '').match(/^[0-9]+[.]$/)) {
    console.log("1")
    return false
  }

  if (latitude.match(/^-/)) {
    if (latitude.match(/^-[.][0-9]+$/)) {
      return false
    }
    if (!latitude.match(/^[0-9-][0-9.]+$/)) {
      console.log("2.a")
      return false
    }
    console.log("3")
    if (Number(latitude.replace('-', '')) <= 90) {
      return true
    } else {
      return false
    }
  } else {
    if (!latitude.match(/^[0-9][0-9.]*$/)) {
      console.log("2.b")
      return false
    }
    console.log("4")
    if(-90 <= Number(latitude) && Number(latitude) <= 90) {
      return true
    } else {
      return false
    }
  }
}

const customLongitude = (longitude) => {
  if (!longitude || typeof longitude !== "string" || longitude === "") {
    return true;
  }

  if (!longitude.match(/^[0-9-]/) || longitude.replace('-', '').match(/^[0-9]+[.]$/)) {
    console.log("1")
    return false
  }

  if (longitude.match(/^-/)) {
    if (longitude.match(/^-[.][0-9]+$/)) {
      return false
    }
    if (!longitude.match(/^[0-9-][0-9.]+$/)) {
      console.log("2.a")
      return false
    }
    console.log("3")
    if (Number(longitude.replace('-', '')) <= 180) {
      return true
    } else {
      return false
    }
  } else {
    if (!longitude.match(/^[0-9][0-9.]*$/)) {
      console.log("2.b")
      return false
    }
    console.log("4")
    if(-180 <= Number(longitude) && Number(longitude) <= 180) {
      return true
    } else {
      return false
    }
  }
}

const customShelterName = (municipalityShelterList, changeFlg, shelterNameDb) => (shelterName) => {
  if (!shelterName || typeof shelterName !== "string" || shelterName === "") {
    return true
  }  
  console.log(municipalityShelterList)
  console.log(shelterName)
  console.log(changeFlg)
  console.log(shelterNameDb)
  // if (municipalityShelterList.includes(shelterName)) {
  //   return false
  // } else {
  //   return true
  // }
  var shelterSet = new Set(municipalityShelterList)
  console.log(shelterSet)
  if (changeFlg) {
    shelterSet.delete(shelterNameDb)
  }
  console.log(shelterSet)
  if (shelterSet.has(shelterName)) {
    return false
  } else {
    return true
  }
}

export default {
  components: {
    "loading":Loading
  },
  mixins: [ mixinFilters ],
  data: function() {
    return {
      areas: null,
      areasAll: [],
      groups: [],
      groupsAll: [],
      disastersAll: [],
      // 画面表示項目
      shelterName: "",
      shelterName_ei: "",
      shelterName_kan: "",
      shelterName_chu_han: "",
      shelterName_chu_kan: "",
      latitude: "",
      longitude: "",

      selectedDisasters: [],
      selectedGroups: [],

      languageRadio: 1,

      isTabActive: 1,

      unfilledPushLanguageStr: "",

      languages: "",
      primaryLanguageId: "",

      municipalityShelterList: null,
      municipalityShelterNames: null,
      shelterNameDb: "",

      // 変更フラグ
      changeFlg: false,
      // 非活性フラグ
      disabledFlg: false,
      // メッセージ
      message: "",
      // アイコン画像
      iconImage: IconImage,
      disasters: null,
      isLoading: false,
      fullPage: true,
      updating: false,
    }
  },
  mounted() {
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg

    if (this.changeFlg) {
      this.getShelterDetail()
    }

    // 自治体情報:プライマリー言語
    this.getMunicipality()
    // 災害種別取得
    this.getDisasterType()

    // 地域取得
    this.getAreaList()
    // 地域グループ
    this.getGroupList()
    // 全避難先
    this.getMunicipalityList()

    console.log("municipality_key disasters")
    console.log(this.$store.getters.getStateMunicipalityKey)
    console.log(this.disasters)
  },
  methods: {
    async getMunicipality() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'primary-language/detail', {
          params: {
            municipality_key: this.$store.getters.getStateMunicipalityKey
          }
        })
        this.languages = response.data.language
        this.primaryLanguageId = response.data.municipality[0].primary_language
        this.message = ""

      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async getDisasterType() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'disaster/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.disasters = response.data

      console.log(this.disasters)

      // チェックボックス全選択用
      for (var i= 0; i< this.disasters.length; i++) {
        this.disastersAll.push(this.disasters[i].disaster_id)
      }

    },
    async getAreaList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_area_list"
        }
      })
      this.areas = response.data

      // // チェックボックス全選択用
      // for (var i= 0; i< this.areas.length; i++) {
      //   this.areasAll.push(this.areas[i].area_id)
      // }

      // 変更の場合は詳細情報取得
      // if (this.changeFlg) {
      //   this.pushDetail()
      // }
    },
    async getGroupList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area-group/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "group_areas"
        }
      })
      this.groups = response.data

      // チェックボックス全選択用
      for (var i= 0; i< this.groups.length; i++) {
        if (this.groups[i].areas.length != 0) {
          this.groupsAll.push(this.groups[i].group_id)
        }
      }
      // 変更の場合は詳細情報取得
      // if (this.changeFlg) {
      //   this.pushDetail()
      // }
    },
    async getMunicipalityList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'shelter/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_shelter_list"
        }
      })

      this.municipalityShelterList = response.data
      this.municipalityShelterNames = this.municipalityShelterList.map(x => x.shelter_name)
      console.log(this.municipalityShelterNames)
    },
    async shelterAdd() {
      // this.updating = true;

      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'shelter/add', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          shelter_name: this.shelterName,
          shelter_name_ei: this.shelterName_ei,
          shelter_name_kan: this.shelterName_kan,
          shelter_name_chu_han: this.shelterName_chu_han,
          shelter_name_chu_kan: this.shelterName_chu_kan,
          latitude: this.latitude,
          longitude: this.longitude,
          selected_group: this.selectedGroups,
          selected_disaster: this.selectedDisasters
        })

        this.$router.push('/shelterList')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      // this.updating = false;
    },
    async shelterUpdate() {
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'shelter/update', {
          shelter_id: this.$store.getters.getStateShelterId,
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          shelter_name: this.shelterName,
          shelter_name_ei: this.shelterName_ei,
          shelter_name_kan: this.shelterName_kan,
          shelter_name_chu_han: this.shelterName_chu_han,
          shelter_name_chu_kan: this.shelterName_chu_kan,
          latitude: this.latitude,
          longitude: this.longitude,
          selected_group: this.selectedGroups,
          selected_disaster: this.selectedDisasters
        })

        this.$router.push('/shelterList')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async getShelterDetail() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'shelter/detail', {
          params: {
            shelter_id: this.$store.getters.getStateShelterId
          }
        })
        console.log(response)

        this.shelterName = response.data.shelter_name
        this.shelterName_ei = response.data.shelter_name_ei
        this.shelterName_kan = response.data.shelter_name_kan
        this.shelterName_chu_han = response.data.shelter_name_chu_han
        this.shelterName_chu_kan = response.data.shelter_name_chu_kan
        this.latitude = response.data.latitude
        this.longitude = response.data.longitude
        this.selectedGroups = response.data.selected_group
        this.selectedDisasters = response.data.selected_disaster
        this.selectedGroups = response.data.shelter_group_ids
        this.selectedDisasters = response.data.shelter_disaster_ids
        this.shelterNameDb = response.data.shelter_name

        // console.log("group: %s", this.selected_group)
        console.log(this.groups.length)
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    modalGroupAreas: function(group) {
      this.$modal.show("modal_group_areas_" + group.group_id)
    },
    close_modal_group_areas: function(group) {
      this.$modal.hide("modal_group_areas_" + group.group_id)
    },
  },
  computed: {
    isAllGroupSelected: {
      get: function () {
        return this.groups ? this.groups.length == this.selectedGroups.length : false;
      },
      set: function (checked) {
        this.selectedGroups = checked ? this.groupsAll : []
      }
    },
    isAllDisasterSelected: {
      get: function () {
        return this.disasters ? this.disasters.length == this.selectedDisasters.length : false;
      },
      set: function (checked) {
        this.selectedDisasters = checked ? this.disastersAll : []
      }
    },
  },
  validations() {
    return {
      shelterName: {
        required,
        maxLength: maxLength(50),
        customShelterName: customShelterName(this.municipalityShelterNames, this.changeFlg, this.shelterNameDb)
      },
      shelterName_ei: {
        maxLength: maxLength(50)
      },
      shelterName_kan: {
        maxLength: maxLength(50)
      },
      shelterName_chu_han: {
        maxLength: maxLength(50)
      },
      shelterName_chu_kan: {
        maxLength: maxLength(50)
      },
      latitude: {
        required,
        maxLength: maxLength(20),
        customLatitude
      },
      longitude: {
        required,
        maxLength: maxLength(20),
        customLongitude
      },
    }
  }
}
</script>

<style scoped>
.tr_title_top {
  text-align: left;
  margin: 20px 0 0 20px;
}
.tr_title {
  text-align: left;
  margin: 10px 0 0 20px;
}
.tr_input {
  margin: 0px 0 0 20px;
  text-align: left;
}
.name_input {
  width: 700px;
}
.name_lati_input {
  width: 300px;
}
.th_area {
  width: 800px;
}
.area_radios_div {
  display: flex;
  margin: 0 0 0 30px;
}
.area_radio_div {
  margin: 0 10px 0 0;
  font-size: smaller;
}
.area_radio_label {
  margin: 2px 0 0 0;
}
.btn_general {
  margin-left: 5px;
}
table th.th_message, .th_area {
  text-align: left;
  padding-left: 10px; 
}
table th.th_check {
  width: 30px;
}
table tr {
  border: none;
}
table tr.tr_top td {
  border: none;
}

.area_name {
  text-align: left;
  padding-left: 10px;
}
.area_name_disabled {
  text-align: left;
  padding-left: 10px;
  background-color: lightgray;
}
.check_area {
  vertical-align: middle;
}

.group_link {
  float: right;
  margin: 0 20px 0 0;
  cursor: pointer;
  color: blue;
}
.modal_header_group {
  /* border-bottom: 1px solid #ddd; */
  height: 20%;
}
.modal_title_group {
  color: black;
  text-align: center;
  line-height:100px;
}
.modal-body_group {
  height: 60%;
  overflow: scroll;
}
.modal-btn_group {
  height: 15%;
}
.modal_btn_div_group {
  text-align: center;
  /* bottom: 10px;
  left: 45%; */
  margin: 0 0 15px 0;
}
</style>